import { About } from "./About";
import { Education } from "./Education";
import { Experience } from "./Employment";
import { Footer } from "./Footer";
import { Intro } from "./Intro";
import { Publications } from "./Publications";

export function App() {
  return (
    <div className="bg-slate-950 text-slate-200 min-h-screen flex flex-col lg:flex-row flex-cols-1 lg:flex-cols-2 justify-left lg:justify-center py-13 px-8">
      <div className="lg:pl-20 lg:min-w-[50vw]">
        <Intro />
      </div>
      <div className="flex flex-col flex-cols-1 mt-20 lg:mt-0 space-y-20 lg:pr-20">
        <About />
        <Experience />
        <Publications />
        <Education />
        <Footer />
      </div>
    </div>
  );
}
